import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down\"><path d=\"M475.384358 804.591835h73.136055V36.568028A36.568028 36.568028 0 0 0 511.952385 0a36.568028 36.568028 0 0 0-36.568027 36.568028zM511.952385 774.213708L175.793174 438.054496a36.568028 36.568028 0 0 0-51.709476 51.709477l336.159211 336.159211a73.136055 73.136055 0 0 0 103.418953 0l336.25444-336.159211A36.568028 36.568028 0 0 0 848.111597 438.054496zM73.136055 950.863945H950.768716a36.568028 36.568028 0 0 1 36.568027 36.568027 36.568028 36.568028 0 0 1-36.568027 36.568028H73.136055A36.568028 36.568028 0 0 1 36.568028 987.431972a36.568028 36.568028 0 0 1 36.568027-36.568027z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/down.svg
// module id = LHwD
// module chunks = 65